import { __assign } from 'tslib';
import * as React from 'react';
import ReactTooltipTrigger from 'react-popper-tooltip';
import TooltipCard from './TooltipCard.esm.js';
import TooltipTrigger from './TooltipTrigger.esm.js';

var Info = function (_a) {
    var tooltipClassName = _a.tooltipClassName, className = _a.className, content = _a.content, onVisibilityChange = _a.onVisibilityChange;
    return (React.createElement("div", { className: className },
        React.createElement(ReactTooltipTrigger, { delayHide: 100, onVisibilityChange: onVisibilityChange, placement: "bottom", tooltip: function (props) { return React.createElement(TooltipCard, __assign({ className: tooltipClassName, content: content }, props)); }, trigger: "hover" }, TooltipTrigger)));
};

export { Info as default };
//# sourceMappingURL=Info.esm.js.map
